import { InjectionToken } from '@angular/core';
import { TooltipMode, TooltipPosition } from './tooltip.directive';

export interface TooltipConfig {
  position: TooltipPosition;
  mode: TooltipMode;
  positionOffset: number;
}

const defaultTooltipConfig: TooltipConfig = {
  position: 'top',
  mode: 'hover',
  positionOffset: 8,
};

/**
 * Self-defaulting so that any app can use `[libTooltip]` without wiring
 * {@link provideTooltip} first. It used to have no factory, which turned every
 * tooltip in a non-opted-in app into a NullInjectorError at render time — a
 * shared directive shouldn't fail on a config that already has defaults.
 * `provideTooltip()` still overrides these app-wide.
 */
export const TOOLTIP_CONFIG = new InjectionToken<TooltipConfig>('Tooltip config for the tooltip directive', {
  providedIn: 'root',
  factory: () => defaultTooltipConfig,
});

export function provideTooltip(config?: Partial<TooltipConfig>) {
  const positionOffset = config?.positionOffset ? Math.abs(config.positionOffset) : defaultTooltipConfig.positionOffset;

  const merged = { ...defaultTooltipConfig, ...config, positionOffset };

  return {
    provide: TOOLTIP_CONFIG,
    useValue: merged,
  };
}
